type Props = {
  propertyName: string;
  src?: string;
};

export default function PropertyMatterport({ propertyName, src }: Props) {
  if (!src) return null;

  return (
    <section className="bg-background-50 py-16 md:py-24 border-b border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="mb-8 md:mb-10">
          <p className="text-[11px] uppercase tracking-[0.24em] text-accent-700 mb-2">
            <span className="inline-block w-5 h-px bg-accent-500 align-middle mr-3" />
            Virtual tour
          </p>
          <h2 className="font-heading text-foreground-950 text-3xl md:text-4xl leading-tight tracking-[-0.01em]">
            Walk through {propertyName}.
          </h2>
        </div>

        <div className="relative overflow-hidden rounded-xl bg-foreground-950 aspect-[16/10] md:aspect-[16/8]">
          <iframe
            src={src}
            className="absolute inset-0 w-full h-full"
            frameBorder="0"
            allow="xr-spatial-tracking; fullscreen"
            allowFullScreen
            title={`${propertyName} virtual tour`}
          />
        </div>
      </div>
    </section>
  );
}
